import { cva } from 'class-variance-authority'

export const logoVariants = cva('block w-auto', {
  variants: {
    variant: {
      wordmark: 'h-[24px]',
      submark: 'h-[24px]',
      favicon: 'size-[24px]',
    },
  },
  defaultVariants: {
    variant: 'wordmark',
  },
})
